import { detectIncognito } from 'detectincognitojs'
import { isBiometricCapableBrowser, verifyIfUserAuthenticatorIsAvailable } from '../../state'

export interface BrowserCapabilities {
  isPrivateBrowsing: boolean
  canSupportBiometric: boolean
  isAuthenticatorAvailable: boolean
}

export const detectPrivateBrowsing = async (): Promise<boolean> => {
  try {
    const isIncognito = await detectIncognito()
    return isIncognito.isPrivate ?? false
  } catch (error) {
    return false
  }
}

export const checkBiometricSupport = (isIframe: boolean): boolean => {
  return isBiometricCapableBrowser(isIframe)
}

export const checkAuthenticatorAvailability = async (): Promise<boolean> => {
  return await verifyIfUserAuthenticatorIsAvailable()
}

export const detectBrowserCapabilities = async (isIframe: boolean): Promise<BrowserCapabilities> => {
  const isPrivateBrowsing = await detectPrivateBrowsing()
  const canSupportBiometric = checkBiometricSupport(isIframe)

  let isAuthenticatorAvailable = false
  if (canSupportBiometric) {
    isAuthenticatorAvailable = await checkAuthenticatorAvailability()
  }

  return {
    isPrivateBrowsing,
    canSupportBiometric,
    isAuthenticatorAvailable,
  }
}
